import { render } from "./Steps.vue?vue&type=template&id=6fa0440a"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"
script.render = render

export default script